<template>
  <div class="d-flex align-center">
    <icons
      v-if="mostrarIcones"
      :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
      :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
      @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
      @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
    />

    <v-btn
      class="ml-2"
      color="primary"
      outlined
    >
      {{ label }}
    </v-btn>
  </div>
</template>

<script>
import ComponenteBase from './ComponenteBase.vue'
import Icons from './Icons.vue'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,
}
</script>
